import fa from "element-ui/src/locale/lang/fa";

const merge = require('webpack-merge')

let config = {
  TOKEN_KEY: "stoken"
}

const customName = process.env.CONF_CUSTOM

const customConfig = {
  // 安徽省合肥市庐州公证处
  lz:{
    baseURL: 'https://hflzgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'安徽省合肥市庐州公证处',
    CUSTOM_CODE:'lz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    // menus: 27, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 江苏省南京市石城公证处
  sc:{
    baseURL: 'https://njscgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'江苏省南京市石城公证处',
    CUSTOM_CODE:'sc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 咸阳市公证处
  xy:{
    baseURL: 'https://xygzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'咸阳市公证处',
    CUSTOM_CODE:'xy',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 内蒙古自治区包头市方正公证处
  fz:{
    baseURL: 'https://btfzgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'内蒙古自治区包头市方正公证处',
    CUSTOM_CODE:'fz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 山西省侯马市公证处
  hm:{
    baseURL: 'https://hmgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'山西省侯马市公证处',
    CUSTOM_CODE:'hm',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 浙江省淳安县公证处
  caxgzc:{
    baseURL: 'https://caxgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'浙江省淳安县公证处',
    CUSTOM_CODE:'caxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 重庆市丰都县公证处
  cqfdgzc:{
    baseURL: 'https://fdgzc.ebaoquan.com/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'重庆市丰都县公证处',
    CUSTOM_CODE:'cqfdgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 辽宁省庄河市公证处
  lnzhgzc:{
    baseURL: 'https://www.lnzhgzc.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省庄河市公证处',
    CUSTOM_CODE:'lnzhgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b000010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 吉林省长春市春信公证处
  jlcccxgzc:{
    baseURL: 'https://jlcccxgzc.houmagongzheng.cn/web',
    ebqAccount:'https://jzqa.jxsncxgzc.com',
    NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
    NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
    CUSTOM_TEST:'吉林省长春市春信公证处',
    CUSTOM_CODE:'jlcccxgzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 广东省江门市五邑公证处
  gdjmwygzc:{
    baseURL: 'https://finance.wygzc.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'广东省江门市五邑公证处',
    CUSTOM_CODE:'gdjmwygzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 重庆市永川公证处
  ycgzc:{
    baseURL: 'https://ycgzc1.ebaoquan.com/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'重庆市永川公证处',
    CUSTOM_CODE:'ycgzc',
    hiddenQr:true,
    hiddenLoginBtn: false,
    hiddenEMailLogin:true, // 登录注册隐藏邮箱方式
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 辽宁省抚顺市法信公证处
  lnfsfxgzc:{
    baseURL: 'https://lnfsfxgzc.houmagongzheng.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'辽宁省抚顺市法信公证处',
    CUSTOM_CODE:'lnfsfxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 甘肃省兰州飞天公证处
  gslzftgzc:{
    baseURL: 'https://gslzftgzc.houmagongzheng.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'甘肃省兰州飞天公证处',
    CUSTOM_CODE:'gslzftgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 云南省昆明市国正公证处
  ynkmgz:{
    baseURL: 'https://ynkmgz.houmagongzheng.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'云南省昆明市国正公证处',
    CUSTOM_CODE:'ynkmgz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 鹤城公证处
  hc:{
    baseURL: 'http://dadi.hcgzc.org.cn:58088/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'鹤城公证处',
    CUSTOM_CODE:'hc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 河北省唐山市华忆公证处
  hbtshy:{
    baseURL: 'https://hbtshygzc.houmagongzheng.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'河北省唐山市华忆公证处',
    CUSTOM_CODE:'hbtshy',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 黑龙江省哈尔滨国信公证处
  hljgxgz:{
    baseURL: 'https://xsfq.hljgxgz.com/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'黑龙江省哈尔滨国信公证处',
    CUSTOM_CODE:'hljgxgz',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
  // 河北省唐山市华忆公证处
  hnxthxgzc:{
    baseURL: 'https://hnxthxgzc.houmagongzheng.cn/web',
    ebqAccount:'',
    NOTAR_WBQ: '',//公证取证
    NOTAR_JZQ: '',//公证电子签
    CUSTOM_TEST:'湖南省湘潭市湖湘公证处',
    CUSTOM_CODE:'hnxthxgzc',
    hiddenQr:true,
    hiddenLoginBtn: true,
    menus: 0b011010, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
  },
};

console.log(33333333333,process.env.CONF_CUSTOM,customConfig['ys'])


if (process.env.CONF_ENV === 'production') {
  if(customName !== 'undefined' && customConfig[customName]){
    config = merge(config,{
      domain:customConfig[customName]
    });
  }else{
    config = merge(config, {
      domain: {
        baseURL: 'https://whzcgz.ebaoquan.com/web',
        ebqAccount:'https://jzqa.jxsncxgzc.com',
        NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
        NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
        hiddenJZQ:true,
      }
    });
  }

} else if (process.env.CONF_ENV === 'sandbox') {
  config = merge(config, {
    domain: {
      baseURL: 'http://nxfqgz.demo.ebq.bz/web',
      ebqAccount:'http://account.demo.ebq.bz',
      mobile_front_url:"http://nxfqgz.demo.ebq.bz/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      VIDEO_SERVER_API: 'http://nxfqgz.demo.ebq.bz/video',
      NOTAR_WBQ: 'http://wbq.demo.ebq.bz',//公证取证
      NOTAR_JZQ: 'http://jzq.demo.ebq.bz',//公证电子签
      SMART_NOTAR_WEB_URL:'http://nxfqgz.demo.ebq.bz/smart',
      hiddenJZQ:true,
    }
  });
} else {
  config = merge(config, {
    domain: {
      // baseURL:'https://whzcgz.ebaoquan.com/web',
      baseURL: 'http://nxfqgz.demo.ebq.bz/web',
      // baseURL: 'http://whzc.demo.ebq.bz/web',
      // baseURL: 'http://192.168.169.119:9001/web',
      // baseURL: 'http://localhost:8080/ccss',
      ebqAccount: 'https://jzqa.jxsncxgzc.com',
      mobile_front_url: "http://nxfqgz.demo.ebq.bz/m",
      video_front_url: 'https://rtc-sandbox.ebaoquan.com',
      // VIDEO_SERVER_API: 'http://192.168.169.22:9003/video',
      VIDEO_SERVER_API: 'http://nxfqgz.demo.ebq.bz/video',
      NOTAR_WBQ: 'https://wbq.jxsncxgzc.com',//公证取证
      NOTAR_JZQ: 'https://jzq.jxsncxgzc.com',//公证电子签
      CUSTOM_CODE:'lz',
      // hiddenQr:true,
      // hiddenLoginBtn: false,
      // hiddenEMailLogin:true, // 登录注册隐藏邮箱方式
      menus: 0b111111, //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
    }
  });
}
export default config



// WEBPACK FOOTER //
// ./src/config/index.js